import {Box} from "@chakra-ui/react";
import {Field as ChakraField} from "@chakra-ui/react";
import {InfoIcon} from "lucide-react";
import React from "react";

export const Field = ({ label, children, errors, withBox = true, isDisabled = false,...props }) => {
    return (
        <Box width="100%" {...props}>
            <ChakraField.Root disabled={isDisabled} invalid={!!errors} display="flex" flexDirection="column" h="100%">
                {(label && label !== '') && <ChakraField.Label fontSize="small" as="b">{label}</ChakraField.Label>}
                {withBox && <Box flex={1}/>}
                {children}
                <ChakraField.ErrorText>
                    <InfoIcon/>
                    {errors}
                </ChakraField.ErrorText>
            </ChakraField.Root>
        </Box>
    );
};

export default Field;
